import { Recommendations } from '../../types';

const favouriteCombinations: Recommendations = [
  {
    id: '54ce634d-3fcf-484c-bf71-7d7e2e3e1745',
    cta: '/music/?genres=rock&moods=uplifting',
    images: [
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_uplifting2.png',
      'https://www.loudly.com/wp-content/uploads/2021/01/md_g_rock.png',
    ],
    description: 'Uplifting Rock',
    tags: [
      {
        name: 'Uplifting',
        url: 'https://www.loudly.com/music/?moods=uplifting',
      },
      {
        name: 'Rock',
        url: 'https://www.loudly.com/music/?genres=rock',
      },
    ],
  },
  {
    id: '18fee75a-083c-4c75-b5b7-2e5f1f26e615',
    cta: '/music/?genres=house&moods=dreamy',
    images: [
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_dreamy.png',
      'https://www.loudly.com/wp-content/uploads/2021/01/md_g_house.png',
    ],
    description: 'Dreamy House',
    tags: [
      {
        name: 'Dreamy',
        url: 'https://www.loudly.com/music/?moods=dreamy',
      },
      {
        name: 'House',
        url: 'https://www.loudly.com/music/?genres=house',
      },
    ],
  },
  {
    id: 'fd0b8535-272d-49bb-b6ba-1bd8fef8efc5',
    cta: '/music/?genres=ambient&moods=chilled',
    images: [
      'https://www.loudly.com/wp-content/uploads/2021/01/md_m_chilled.png',
      'https://www.loudly.com/wp-content/uploads/2021/01/md_g_ambient.png',
    ],
    description: 'Chilled Ambient',
    tags: [
      {
        name: 'Chilled',
        url: 'https://www.loudly.com/music/?moods=chilled',
      },
      {
        name: 'Ambient',
        url: 'https://www.loudly.com/music/?genres=ambient',
      },
    ],
  },
];

export default favouriteCombinations;
